import { createReducer } from '@reduxjs/toolkit';
import { actions } from './actions';
const initialState = {
    data: {
        ambassadorName: '',
        ambassadorPhoto: {
            _path: '',
        },
        ambassadorIntro: {
            html: '',
        },
        ambassadorPhone: '',
        ambassadorEmail: '',
        ambassadorWebsiteUrl: '',
        priority: 0,
        _path: '',
    },
};
function setAmbassadorDetailsData(state, { payload }) {
    return {
        ...state,
        data: payload,
    };
}
export const reducer = createReducer(initialState, (builder) => {
    builder
        .addCase(actions.setAmbassadorDetailsData, setAmbassadorDetailsData)
        .addCase(actions.setInitialAmbassadorDetailsData, () => initialState);
});
